import { GenreTypes, ProjectTypes, StatusTypes } from 'models'
import { Moment } from 'moment'
import { PaginationProps, SortDirection } from 'utilities'

export enum ProjectsTableSortProps {
  NAME = 'name',
  TYPE = 'type',
  ADDED_AT = 'added at',
  GENRE = 'genre',
  INPUT_TOKEN_USED = 'input token used',
  OUTPUT_TOKEN_USED = 'output token used'
}

export type ProjectsTableSearchProps = {
  name: string
  type: ProjectTypes
  addedAtStart: Moment
  addedAtEnd: Moment
  tags: string
  genre: GenreTypes
  status: StatusTypes
  published: boolean
}

export const projectsTableInitialPaginationProps: PaginationProps<ProjectsTableSortProps> = {
  page: 0,
  size: 15,
  sortDirection: SortDirection.ASC,
  sortProp: ProjectsTableSortProps.NAME,
  totalElements: 0,
  totalPages: 0
}

export const projectsTableInitialSearchProps: ProjectsTableSearchProps = {
  name: '',
  type: '' as ProjectTypes,
  addedAtStart: null,
  addedAtEnd: null,
  tags: '',
  genre: '' as GenreTypes,
  status: '' as StatusTypes,
  published: '' as unknown as boolean
}

export const projectsTableNeedTimeoutProps: Array<keyof ProjectsTableSearchProps> = [
  'name', 'tags'
]
